import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";
import { BankAccountTransactions } from "@/modules/bank/application/BankAccountTransactions"

export class MarkAsReviewed {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly q_dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(transaction_ids:[string], value:boolean, idBankAccount:String|Number, listFilters?): Promise<any> {
    let args = { 
      transaction_ids: transaction_ids,
      value: value
    }
    if (value){
      this.frontend.loading_mark_as_reviewed_transactions(true)
    } else {
      this.frontend.loading_uncheck_reviewed_transactions(true)
    }
    await this.dispatcher.dispatch('mark.as.reviewed', args)
    if (value){
      this.frontend.loading_mark_as_reviewed_transactions(false)
    } else {
      this.frontend.loading_uncheck_reviewed_transactions(false)
    }
    await new BankAccountTransactions(this.q_dispatcher, this.frontend).run_filter(idBankAccount, listFilters, this.frontend.$refs.bankSimpleFilters.option_selected, this.frontend.limit, this.frontend.offset)
  }
}